import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import routes from "constants/routes";
import assets from "assets";

import BoxWithBackground from "components/styled/Box_With_Background";
import Level from "components/layout/Level";
import LevelLeft from "components/layout/Level_Left";
import LevelRight from "components/layout/Level_Right";
import LevelItem from "components/layout/Level_Item";

import NavBarProfileIcon from "components/styled/Nav_Bar_Profile_Icon";
import NewNotificationBadge from "components/SmartTile/NewNotificationBadge";

const ACTIVE_STYLE = {
  borderBottom: "4px solid hsl(217, 71%, 53%)",
};

// --- PUUTTUVA KOMPONENTTI LISÄTTY JA SUOJATTU ---
const NavItemsRight = (props) => {
  const user = props.auth?.user || {}; // Suojaus: vältetään 'undefined' virheet
  
  return (
    <LevelRight style={props.style}>
      {routes.map(
        ({ path, img, permaLink, hideIfSignupIncomplete, role }, i) => {
          if (props.litterMemberDashboard || props.petDashboard) return null;
          if (!permaLink) return null;
          if (role !== props.role) return null;

          // SUOJAUS: Käytetään ?. jotta signupComplete ei kaada sovellusta
          if (hideIfSignupIncomplete && !user?.signupComplete) return null;

          return (
            <LevelItem key={i}>
              <div style={{ paddingTop: 2, minHeight: 44 }}>
                <NavLink
                  exact={true}
                  to={path}
                  activeStyle={ACTIVE_STYLE}
                  className="box"
                  style={{ padding: 4 }}
                >
                  <figure className="image is-28x28">
                    <img src={img?.src} alt={img?.alt} />
                  </figure>
                </NavLink>
              </div>
            </LevelItem>
          );
        }
      )}
      {props.showSelectedProfile && props.mobile && (
        <LevelItem>
          <NavBarProfileIcon {...props} />
        </LevelItem>
      )}
    </LevelRight>
  );
};

class Navigation extends Component {
  render() {
    const { isAuthed, auth, location } = this.props;

    // 1. HAETAAN DATA TURVALLISESTI
    const user = auth?.user || {};
    const account = user?.account || {}; 
    const completeRegistrationRequired = account?.completeRegistrationRequired;

    // 2. REITTILOGIIKKA
    const currentPath = location?.pathname || "";
    const displayRight =
      currentPath === "/userhome" || currentPath === "/providerhome"
        ? "block"
        : "none";

    const pathnameArray = currentPath.split("/");
    const petDashboard = pathnameArray[2] === "dashboard";
    const litterMemberDashboard = pathnameArray[3] === "litter_member_dashboard";
    const showSelectedProfile = !!(petDashboard || litterMemberDashboard);

    // 3. LOGIIKKA
    if (!isAuthed) return null;

    // Jos dataa vielä ladataan, odotetaan
    if (!user || Object.keys(user).length === 0) return null;

    // Jos rekisteröinti kesken, piilotetaan navigaatio
    if (completeRegistrationRequired) return null;

    return (
      <NavBar
        {...this.props}
        displayRight={displayRight}
        showSelectedProfile={showSelectedProfile}
        petDashboard={petDashboard}
        litterMemberDashboard={litterMemberDashboard}
      />
    );
  }
}

const NavBar = (props) => {
  if (props.mobile) {
    return (
      <BoxWithBackground
        style={{
          height: 55,
          paddingTop: 4,
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: "env(safe-area-inset-bottom, 0)",
        }}
      >
        <Level className="is-mobile">
          <NavItemsLeft {...props} />
          <NavItemsRight {...props} style={{ display: props.displayRight }} />
        </Level>
      </BoxWithBackground>
    );
  }
  return (
    <Level className="is-mobile">
      <NavItemsLeft {...props} />
      <NavItemsRight {...props} />
    </Level>
  );
};

const NavItemsLeft = (props) => {
  return (
    <LevelLeft>
      {routes.map(({ path, img, breadcrumb }, i) => {
        if (!breadcrumb) return null;
        if (props.location.pathname.indexOf(path) > -1) {
          return (
            <LevelItem key={i}>
              <div style={{ paddingTop: 2, minHeight: 44 }}>
                <NavLink
                  exact={true}
                  to={path}
                  activeStyle={ACTIVE_STYLE}
                  className="box"
                  style={{ padding: 4, ...props.style }}
                >
                 <figure className="image is-28x28">
  {props.newNotifications && path === "/userhome" && (
    <NewNotificationBadge value={props.notificationCount || ""} />
  )}
  <img src={img.src} alt={img.alt} />
</figure>
                </NavLink>
              </div>
            </LevelItem>
          );
        }
        return null;
      })}
      {/* ... (muut NavItemsLeft linkit pysyvät samoina) ... */}
    </LevelLeft>
  );
};

const mapStateToProps = (state) => {
  // SUOJAUS: Varmistetaan että reducers ja auth ovat olemassa
  const auth = state.reducers?.auth || {};
  const newNotifications = state.reducers?.contacts?.pendingRequests?.length > 0;
  
  return {
    auth: auth,
    user: auth.user || {},
    isAuthed: auth.isAuthenticated,
    newNotifications,
    mobile: state.browser?.lessThan?.medium, // Oletus: mobiilitila reduxista
    role: auth.user?.account?.role
  };
};

export default connect(mapStateToProps)(Navigation);